import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HeightWidthTuple } from 'src/app/model/util-classes/height-width-tuple';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { WindowStickerSizeMaterialsForFormatResult } from './window-sticker-size-materials-for-format-result';
import { Observable } from 'rxjs';
import { _post } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class WindowStickerSizeMaterialsForFormatControllerRequestService {
  private static BASE_URL = '/window_sticker_sizes/materialsForFormat';
  private readonly post: <T>(
    path: string,
    body: HeightWidthTuple[],
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserialize = (res) =>
    res as WindowStickerSizeMaterialsForFormatResult;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      WindowStickerSizeMaterialsForFormatControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getMaterialsForFormats(
    tuples: HeightWidthTuple[]
  ): Promise<WindowStickerSizeMaterialsForFormatResult> {
    return this.post('', tuples, this.deserialize).toPromise();
  }
}
